<div class="flex justify-content-center align-items-center h-12">
  <p-blockUI [blocked]="isLoading">
    <div id="center">
      <p-progressSpinner [style]="{ width: '100px', height: '200px' }" strokeWidth="6"></p-progressSpinner>
    </div>
  </p-blockUI>
</div>

<div class="flex flex-column justify-content-between">
  <div class="flex flex-column px-3" *ngIf="duplicateSampleFound">
    <app-duplicate-sample-selection [duplicateSamples]="duplicateSamples" (sampleSelectionEmitter)="selectedSampleFromDuplicate($event)" [skipSampleDisability]="true"></app-duplicate-sample-selection>
  </div>
  <div class="flex w-full" *ngIf="sample !== null">
    <h4 class="p-2" *ngIf="sample !== null">
      Sample Information: <strong>{{ sample[searchType] }}</strong>
    </h4>
  </div>
  <div class="flex flex-column" *ngIf="sample !== null">
    <p-panel header="Sample Metadata" class="p-2" [toggleable]="true">
      <p-table [value]="sample | keyvalue" [scrollable]="true" scrollHeight="80vh" styleClass="p-datatable-striped mt-3 mx-1 md:text-sm lg:text-md">
      <ng-template pTemplate="header">
        <tr>
          <th>Property</th>
          <th>Value</th>
        </tr>
      </ng-template>
        <ng-template pTemplate="body" let-fields>
          <tr *ngIf="checkIfValidState(fields)">
            <td>{{ renameKeys(fields.key) }}</td>
            <td>{{ formatData(fields) }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="p-2 flex gap-3 flex-column">
        <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" (click)="emitDownloadEvent()" label="Download Excel"></button>
        <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" (click)="showBatchComment()" label="Batch Comments"></button>
        <button pButton class="w-15rem action-button h-2rem md:text-sm text-primary px-0" type="button" (click)="showSampleComment()" label="Sample Comments"></button>
      </div>
    </p-panel>
  </div>
  <div
    class="flex flex-column lg:w-1/2"
    *ngIf="sampleProcessSteps?.length !== 0"
  >
    <p-panel header="Sample Process Data" [toggleable]="true" class="p-2">
      <div class="p-2">
        <p-table
          [value]="sampleProcessSteps"
          styleClass="p-datatable-striped mt-3 mx-1 md:text-sm lg:text-md"
          [scrollable]="true"
          scrollHeight="80vh"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Batch ID</th>
              <th>Position</th>
              <th>Step Action</th>
              <th>PUID</th>
              <th>Time</th>
              <th>Equipment</th>
              <th>Reagents</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-step>
            <tr>
              <td>
                  <div>{{ step.plateId }}</div>
                  <div *ngIf="step.batchID">({{ step.batchID }})</div>
              </td>
              <td>{{ step.position }}</td>
              <td>
                <div *ngFor="let action of step.stepAction.split(',')">
                  {{ action }}
                </div>
              </td>
              <td>{{ step.puid }}</td>
              <td>{{ step.stepTime }}</td>
              <td>
                <div *ngFor="let equipment of step.equipment">
                  {{ equipment.machineType }} : {{ equipment.machineBarcodes }}
                </div>
              </td>
              <td>
                <div *ngFor="let chem of step.reagents">
                  {{ chem.chemical }} : {{ chem.lots }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-panel>
  </div>
</div>

<p-dialog header="{{ getCommentsDialogHeader() }}" [(visible)]="displaySampleComment" [maximizable]="true" [modal]="true" [style]="{ 'width': '50vw', 'height': '65vh' }" [breakpoints]="{'960px':'75vw','648px':'85vw'}">
  <app-comment *ngIf="sample !== null" [selectedLabID]="selectedLabID" [puid]="puid" [displayDialog]="displaySampleComment"  [showSampleComment]="true" [sampleID]="sample?._id" [sampleBarcode]="sample?.barCode"
     [samplePlateComments]="samplePlateComments" [sampleSearch]=true (onCommentClosed)="displaySampleComment = false">
  </app-comment>
</p-dialog>

<p-dialog header="{{ getCommentsDialogHeader() }}" [(visible)]="displayBatchComment" [maximizable]="true" [modal]="true" [style]="{ 'width': '50vw', 'height': '65vh' }" [breakpoints]="{'960px':'75vw','648px':'85vw'}">
  <app-comment *ngIf="sample !== null" [selectedLabID]="selectedLabID" [plateStatus]="'ADMIN_CHANGE'" [puid]="puid" [displayDialog]="displayBatchComment" [plateID]="sample?.sourcePlateID"
      [showPlateComment]="true" [sampleSearch]=true [samplePlateComments]="samplePlateComments" (onCommentClosed)="displayBatchComment = false">
  </app-comment>
</p-dialog>
